document.addEventListener('DOMContentLoaded', (e) => {
  document.getElementById('imginput').addEventListener('change', (e) => {
    processFile(e.target.files[0]);
  });

  document.getElementById('copybutton').addEventListener('click', (e) => {
    const result = document.getElementById('result');
    result.select();
    document.execCommand('copy');
    document.getElementById('copystate').removeAttribute('class');
  });
});

const processFile = (file) => {
  const maxWidth = parseInt(document.getElementById('maxwidth').value) || Infinity;

  let maxSize = parseInt(document.getElementById('maxsize').value);
  if (maxSize < 1024) maxSize = 1024;

  document.getElementById('copystate').setAttribute('class', 'hidden');

  const reader = new FileReader;

  reader.addEventListener('load', (e) => {
    const tmpImg = new Image;

    tmpImg.addEventListener('load', (e) => {
      const dataURL = findOptimalDataURL(tmpImg, maxWidth, maxSize);
      const imgTag = `<img src="${dataURL}">`;

      document.getElementById('result').innerText = imgTag;
      document.getElementById('resultsize').innerText = imgTag.length;

      if (imgTag.length > 65535) {
        document.getElementById('resulttoobig').removeAttribute('class')
      } else {
        document.getElementById('resulttoobig').setAttribute('class', 'hidden');
      }

      document.getElementById('resultinfo').removeAttribute('style');
    });

    tmpImg.src = reader.result;
  });

  reader.readAsDataURL(file);
};

document.addEventListener('paste', (e) => {
  processFile(e.clipboardData.files[0]);
});

const findOptimalDataURL = (img, maxWidth, maxSize) => {
  const canvas = document.createElement('canvas');

  if (img.width > maxWidth) {
    canvas.width = maxWidth;
    canvas.height = img.height * (maxWidth / img.width);
  } else {
    canvas.width = img.width;
    canvas.height = img.height;
  }

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  let dataURL = canvas.toDataURL('image/webp', 1);
  let quality = 1.0, qStep = 0.05;

  while(dataURL.length > maxSize && quality > 0.01) {
    if (quality - qStep < qStep) qStep /= 2;
    quality -= qStep;

    dataURL = canvas.toDataURL('image/webp', quality);

    // console.log('quality', quality);
    // console.log('size', dataURL.length);
  }

  return dataURL;
};
